<template>
    <el-switch v-model="modelVal"
        :active-color="activeColor"
        :inactive-color="inactiveColor"
        v-bind="$attrs"
        v-on="$listeners"/>
</template>

<script>
import { createComponent } from '@vue/composition-api'

export default createComponent({
    props: {
        value: {
            type: Boolean
        },
        activeColor: {
            type: String,
            default: '#009688'
        },
        inactiveColor: {
            type: String,
            default: '#ddd'
        }
    },
    computed: {
        modelVal: {
            get() {
                return this.value
            },
            set(newVal) {
                this.$emit('input', newVal)
            }
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep.el-switch {
    position: relative;

    &::before {
        content: '停用';
        position: absolute;
        left: 23px;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        line-height: 16px;
        font-size: 12px;
        color: #fff;
        z-index: 1;
    }

    &.is-checked::before {
        content: '启用';
        color: #fff;
        left: 10px;
    }

    .el-switch__core {
        width: 57px !important;
    }
}
</style>
